<div class="page has-breadcrumb">
  <astrobin-read-only-mode *ngIf="(readOnlyMode$ | async) === true; else editTemplate"> </astrobin-read-only-mode>
</div>

<ng-template #editTemplate>
  <ng-container *ngIf="isBrowser; else loadingTemplate">
    <form [formGroup]="imageEditService.form">
      <formly-form
        [fields]="imageEditService.fields"
        [form]="imageEditService.form"
        [model]="imageEditService.model"
      ></formly-form>
    </form>

    <div
      *ngIf="imageEditEquipmentFieldsService.creationMode"
      (click)="promptToExitEquipmentItemCreationMode($event)"
      class="equipment-item-creation-mode-overlay"
    ></div>
  </ng-container>
</ng-template>

<ng-template #remoteSourceLabelTemplate let-item="item">
  <span class="code">{{ item.label }}</span>
  <span *ngIf="imageEditService.isSponsor(item.value)" class="remote-affiliate-sponsor">(sponsor)</span>
</ng-template>

<ng-template #remoteSourceOptionTemplate let-item="item">
  <span class="code">{{ item.label }}</span>
  <span *ngIf="imageEditService.isSponsor(item.value)" class="remote-affiliate-sponsor">(sponsor)</span>
</ng-template>

<ng-template #collaboratorLabelTemplate let-item="item">
  <div class="d-flex align-items-center">
    <img [src]="item.avatar | orDefaultAvatar" class="avatar-sm me-2" alt="{{ item.label }}" />
    <span>{{ item.label }}</span>
  </div>
</ng-template>

<ng-template #collaboratorOptionTemplate let-item="item">
  <div class="d-flex align-items-center">
    <img [src]="item.avatar | orDefaultAvatar" class="avatar-sm me-2" alt="{{ item.label }}" />
    <span>{{ item.label }}</span>
  </div>
</ng-template>

<ng-template #equipmentStepPreambleTemplate>
  <ng-container *ngIf="presets$ | async as presets">
    <div *ngIf="presets.length > 0" class="alert alert-dark mb-5">
      <p class="mb-3 text-muted">
        {{ "Apply one of your saved setups, or fill in the form below manually." | translate }}
      </p>
      <div class="d-flex flex-row flex-wrap gap-3 align-items-center">
        <div *ngFor="let preset of presets">
          <astrobin-equipment-preset
            [buttonOverlayLabel]="'Apply' | translate"
            [preset]="preset"
            (presetClicked)="onPresetClicked($event)"
          ></astrobin-equipment-preset>
        </div>

        <div (click)="onPresetCreateClicked()" class="create-preset">
          <fa-icon icon="plus"></fa-icon>
          <span translate="Add setup"></span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #equipmentStepButtonsTemplate>
  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!imageEditService.hasEquipmentItems()"
    (click)="onClearEquipmentClicked()"
    id="clear-equipment-btn"
    class="btn btn-outline-danger me-2"
  >
    {{ "Clear" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!imageEditService.hasEquipmentItems()"
    (click)="onSaveEquipmentPresetClicked()"
    id="save-preset-btn"
    class="btn btn-outline-secondary"
  >
    {{ "Save setup" | translate }}
  </button>
</ng-template>

<ng-template #acquisitionAdditionalButtonsTemplate>
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="onCopyAcquisitionSessionsFromAnotherImageClicked($event)"
    id="copy-acquisition-sessions-from-another-image-btn"
    class="btn btn-outline-secondary"
  >
    {{ "Copy from another image" | translate }}&hellip;
  </button>

  <div class="btn-group" ngbDropdown placement="bottom-left">
    <button
      [class.loading]="loadingService.loading$ | async"
      (click)="onImportFromCsvClicked($event)"
      id="import-from-csv-btn"
      class="btn btn-outline-secondary me-0"
      type="button"
    >
      {{ "Import from CSV" | translate }}&hellip;
    </button>

    <button
      [attr.aria-label]="'CSV options' | translate"
      [class.loading]="loadingService.loading$ | async"
      id="csv-dropdown-toggle"
      class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
      ngbDropdownToggle
      type="button"
    >
      <span class="visually-hidden">{{ "Toggle dropdown" | translate }}</span>
    </button>

    <div [attr.aria-labelledby]="'csv-dropdown-toggle'" ngbDropdownMenu>
      <button [disabled]="!hasAcquisitions" (click)="onExportToCsvClicked($event)" class="dropdown-item" type="button">
        <fa-icon [icon]="['fas', 'download']" class="me-2"></fa-icon>
        {{ "Export to CSV" | translate }}
      </button>
    </div>
  </div>

  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="onOverrideAcquisitionFormClicked($event)"
    id="override-acquisition-form-btn"
    class="btn btn-outline-secondary"
  >
    {{ "Override acquisition form" | translate }}&hellip;
  </button>
</ng-template>

<ng-template #stepperButtonsTemplate>
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="onSave($event)"
    id="save-button"
    class="btn btn-primary"
  >
    {{ "Save" | translate }}
  </button>
</ng-template>

<ng-template #acquisitionFilterSelectFooterTemplateExtra>
  <div class="text-muted">
    {{ "To add more, go back to the Equipment step." | translate }}
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #presetCreateOffcanvas let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ "Add setup" | translate }}</h5>
    <button (click)="offcanvas.close()" class="btn-close" aria-label="Close" type="button"></button>
  </div>

  <div class="offcanvas-body">
    <div class="alert alert-mini alert-info mb-5">
      {{ "Please note: you can also just add equipment to your image and save it as a setup later." | translate }}
    </div>

    <astrobin-equipment-preset-editor
      [preset]="null"
      (presetSaved)="offcanvas.close()"
    ></astrobin-equipment-preset-editor>
  </div>
</ng-template>
